export const ABOUT_TEXT = `I'm a developer passionate about robotics and software engineering. I enjoy building algorithms for autonomous robots (both ground and aerial) and developing software applications that solve real-world problems.
When I'm not coding, you'll find me exploring the outdoors, playing sports, working on cars, or building random shenanigans.`;

export const SKILLS = [
  'Pytorch', 'NumPy', 'Matplotlib', 'Pandas', 'Scikit', 'MatPlotlib', 'C++', 'C', 'Java', 'LaTeX', 'Linux',
  'Git', 'ROS/(2)', 'React', 'TypeScript', 'Node.js', 'Tensorflow', 'Docker', 'Fusion 360', 'OnShape', 'AutoCAD',
  'Arduino', 'Raspberry Pi', 'GNC', 'Ansys', 'CFD' 
];


export const PROJECTS = {
  'stanford musallem center': {
    title: 'Stanford Musallem Center for Biodesign - Pediatric Wearable Device',
    description: "Led development of pediatric wearable devices for patients in the NICU/PICU post-cardiovascular surgery at Stanford Hospital. Worked with BLE-enabled microcontrollers (ESP32) to pair with EKGs and device for continuous monitoring; Developed circuits in KiCAD and programmed in C and C++.",
    tech: ['Bluetooth', 'ESP32', 'C++', 'C', 'Raspberry Pi', 'KiCAD', 'Bioengineering'],
    showModel: false,
  },

  'NASAMINDS Grand Champions Project': {
    title: 'NASAMINDS Grand Champions Project',
    description: "RFID based item locator system for the NASA MINDS Competition. Team of 10 won national Grand Champions title in 2025. Project included building a system with RFID tags, antennas, custom PCBs, Arduinos, and Raspberry Pi all under $500. System consisted of two parts, Echo and Eureka, to locate item in a 10x10 feet area and then precisely find the item. Echo was the general locator on the computer system and Eureka was a handheld device with a screen and buttons to navigate to the item with a centimeter accuracy. Code written in C++ and C. Project concept deployed to NASA's Artemis II mission.",
    tech: ['RFID', 'Arduino', 'C++', 'C', 'Raspberry Pi', 'Electrical Engineering'],
    link: 'https://news.fullcoll.edu/applied-engineering-team-dominates-at-2024-nasa-minds-competition/',
    showModel: false,
  },
  'CavMaps': {
    title: 'CavMaps @ University of Virginia',
    description: "Developing an internal 'Apple Maps' for University of Virginia. Integrating live route data, bus locations from TransLoc API, and different construction sites by custom user alerts.",
    tech: ['Java','Swift', 'Kotlin', 'SQL'],
    link: '#',
    showModel: false,
  },
  'Motorsports @ University of Virginia': {
    title: 'Motorsports Club @ University of Virginia',
    description: "Part of the Motorsports Club at University of Virginia. Building a full electric racing go-kart from scratch. Working on embedded systems, driver interface, as well as chasis and suspension design. Project is bulit to compete at the Formula SAE Electric competition.",
    tech: ['Java','Python', 'C++', 'Fusion 360', 'Welding', 'Mechanical Engineering'
    ],
    link: '#',
    showModel: false,
  },
  'BD Spot': {
    title: 'Dynamic Autonomous Navigation using the Boston Dynamics Spot Robot Dog',
    description: "Project was two-fold: 1. Implementing ROS2 and SLAM into the Boston Dynamics Spot robot dog using Linux and Python. (Spot doesn't have SLAM natively); 2. Implimented a computer-vision based algorithm to autonomously navigate through obstacles within the building. ",
    tech: ['ROS2','OpenCV', 'PyTorch', 'TensorFlow', 'Python', 'SLAM', 'C++'],
    link: '#',
    showModel: false,
  },
  'A2RL Competition': {
    title: 'A2RL Competition With Fullerton College Drone Team',
    description: "Developed an autonomous package carrying drone for the A2RL copmetition hosted annually in Dubai. Drone was designed to autonomously navigate to waypoints and deliver a package at a target location.",
    tech: ['ROS2','OpenCV', 'PyTorch', 'TensorFlow', 'C++'],
    link: '#',
    showModel: false,
  },
  'F1 Car Full CAD Model': {
    title: 'F1 Car CAD Model',
    description: 'A full CAD model of an F1 car created in OnShape.',
    tech: ['CAD', 'OnShape', 'Orca Slice 3D','3D Printing'],
    link: '#',
    modelPath: '/models/F1Car.stl',
    modelRotation: [-90, 0, -90],
    modelScale: 1.7, 
  },
  'Zircon': {
    title: 'X-51 Hypersonic ScramJet',
    description: 'A full CAD model of an X-51 Scramjet created on Fusion 360.',
    tech: ['CAD', 'Fusion 360'],
    link: '#',
    modelPath: '/models/ZirconHypersonic.stl',
    modelRotation: [0, 0, 0],
    modelScale: 1.8,
  },
  'Ferrari Full CAD Model': {
    title: 'Ferrari CAD Model',
    description: 'A full CAD model of a Ferrari car created in OnShape.',
    tech: ['CAD', 'OnShape', 'Orca Slice 3D','3D Printing'],
    link: '#',
    modelPath: '/models/Ferrari.stl',
    modelScale: 1.7,
  },
  'RX Shield Full CAD Model': {
    title: 'Materials and Manufacturing Directorate Shield CAD Model',
    description: "The Materials and Manufacturing Directorate's Shield at the Air Force Research Laboratory. Given to retiring Associate Director as a retirement gift from the directorate. CAD Model created in Fusion 360.",
    tech: ['CAD', 'Fusion 360', 'Prusa Slicer','3D Printing'],
    link: '#',
    modelPath: '/models/RXShield.stl',
    modelRotation: [-90, 0, 0],
  },
};

export const RESEARCH = {
    'uva-cral': {
      title: 'Undergraduate Researcher - CRΔL Lab @ University of Virginia Link Lab ',
      description: 'Developing novel control barrier function methods for agile mobility for bi-pedal and quadruped robots with non-holonomic bicycle models in the Chandra Robotics Autonomy Lab.',
      tech: ['Julia','Control Theory', 'GNC', 'Control Barrier Functions', 'ACBFs', 'VCBFs', 'DMPCs'],
      paperLink: 'https://cral-uva.github.io/people/sagar_shah/index.html',
      paperLinkLabel: 'View Research Page',
    },
    'air-force-research-lab-RA': {
      title: 'Student Researcher - Control Science Center @ Air Warfare Directorate @ Air Force Research Laboratory @ Wright-Patterson AFB',
      description: 'Summer 2025 - Present. Multi-Directional Control Barrier Functions for Trajectory Optimization in Adversarial Environments; Worked on next-generation control operations using control theory algorithms such as Control Barrier Functions in Julia for UAV navigation and adversarial environment planning,',
      tech: ['Julia', 'Control Theory', 'GNC','Control Barrier Functions'],
      paperLink: 'https://arc.aiaa.org/doi/10.2514/6.2026-4495',
      paperLinkLabel: 'View Published Paper',
      simulationGif: '/research/afrl.gif',
      simulationGifAlt: 'Control barrier function trajectory optimization simulation',
    },
    'stanford-biodesign': {
      title: 'BioDesign Consultant - Mussallem Center for Biodesign',
      description: 'September 2025 - Present. Created tutorials to help Biodesign attendees conceptualize, prototype, and evaluate early-stage digital health solutions with modern AI techniques, including ML workflows in Google Colab. Worked on pediatric wearable devices for NICU and PICU patients after cardiovascular surgery at Stanford Hospital, using BLE-enabled microcontrollers paired with EKGs for continuous monitoring in C and C++.',
      tech: ['Digital Health', 'AI', 'Google Colab', 'BLE', 'C', 'C++', 'Wearables'],
      link: '#',
    },
    'air-force-research-lab-RX': {
      title: 'Student Research Intern - Materials and Manufacturing Directorate @ U.S. Air Force Research Laboratory',
      description: 'Summer 2024 - Summer 2026. Research intern at Materials and Manufacturing Directorate at Wright-Patterson AFB. Programmed a Boston Dynamics Spot robot dog in the CAMS Lab to autonomously cut a ribbon using computer vision and ROS for a lab inauguration ceremony. Created an ARES OS-compatible GUI for a Soft Materials lab.',
      tech: ['Robotics', 'ROS', 'Computer Vision', 'Julia', 'Control Theory', 'ARES OS'],
      link: '#',
    },
    'fuller-lab-stanford': {
      title: 'Student Researcher - Fuller Lab, Stanford Engineering',
      description: "Spring 2023 - Fall 2024. Developed a machine learning pipeline for computer-vision-based pupil detection using Meta's SAM 2 model with PyTorch. Co-developed a React and TypeScript app deployed to Alcon for detecting ophthalmological disease.",
      tech: ['PyTorch', 'Computer Vision', 'SAM 2', 'React', 'TypeScript', 'Digital Health'],
      link: '#',
    },
    'ucr-neuro': {
      title: "High School Researcher - University of California, Riverside Laksari Lab",
      description: 'Spring 2024 - Fall 2024. Developed machine learning algorithm in Matlab to detect early stage stroke symptoms using MRI and CT scans. Worked in collaboration with hospitals and lab at Arizona State University.',
      tech: ['MatLab', 'AI', 'CNNs', 'Python', 'C', 'C++'],
      link: '#',
    },
};


export const EXPERIENCE = {
  'air-force-research-lab-RA': {
    title: 'Student Intern / Researcher',
    description: 'Summer 2025 - Present; Control Science Center @ Air Warfare Directorate @ Air Force Research Laboratory @ Wright-Patterson AFB',
    logo: '/experience/afrl.png',
    logoAlt: 'Air Force Research Laboratory logo',
  },
  'stanford-biodesign': {
    title: 'Staff BioDesign Consultant',
    description: 'September 2025 - Present; Mussallem Center for Biodesign at Stanford University; Full-time staff researcher developing wearable devices for pediatric patients after cardiovascular surgery.',
    logo: '/experience/stanford.png',
    logoAlt: 'Stanford Biodesign logo',
  },
  'air-force-research-lab-RX': {
    title: 'Student Intern / Researcher',
    description: 'Summer 2024 - Summer 2026; Materials and Manufacturing Directorate @ Air Force Research Laboratory @ Wright-Patterson AFB',
    logo: '/experience/afrl.png',
    logoAlt: 'Air Force Research Laboratory logo',
  },
  'BAE Systems United Kingdom': {
    title: 'Student Intern',
    description: 'Oct 2025 - Oct 2025; BAE Systems United Kingdom',
    logo: '/experience/baesystems.png',
    logoAlt: 'BAE Systems logo',
  },
};

export const HOBBIES = {
  'musician': {
    title: 'Tabla Player (Classical Indian Drums)',
    description: 'Have been playing the tabla for 15 years now. Performed at various local, national, and international concerts. Honored to play on the same stage as maestros such as Pandit Anindo Chatterjee, Ustaad Zakir Hussain, Pandit Sadanand Naimpalli, and more. One concert linked below.',
    paperLink: 'https://www.youtube.com/watch?v=RTUXNs6Rf98',
    paperLinkLabel: 'Watch Performance',
    logo: '/hobbies/tabla.png',
  },
  'car-enthusiast':
  {
    title: 'Car Enthusiast', 
    description: 'Have been working on cars for the past 10+ years. Modified and have rebuilt engines, tuned ECUs, installed exhaust pipes, worked on organizing team of OC Cars and Coffee (the biggest car meet in Southern California). Notable cars worked on include: BMW 335i, M2 Competition, M3 Competition (G80 series), M4CS, M8; Audi R8, Q8 Quattro; Ferrari SF90; McLaren 765LT, P1; Porsche GT3RS; Toyota Corolla. Love go-karting and track racing.',
    logo: '/hobbies/Car.jpeg',
  },
  'photography':
  {
    title: 'Photography', 
    description: 'Although recent, a fun passion to capture the moments and memories of life. Love to capture nature, landscapes, and cars. Shoot pictures off of Iphone 14 to demonstrate viability of taking quality photos through every-day devices.',
    logo: '/hobbies/Photo.jpeg',
    images: ['/hobbies/Photo.jpeg', '/hobbies/Photo12.jpeg','/hobbies/Photo3.jpeg','/hobbies/Photo5.jpeg','/hobbies/Photo10.jpeg','/hobbies/Photo9.jpeg','/hobbies/Photo7.jpeg','/hobbies/Photo4.jpeg','/hobbies/Photo6.jpeg','/hobbies/Photo13.jpeg','/hobbies/Photo15.jpeg','/hobbies/Photo2.jpeg','/hobbies/Photo8.jpeg', '/hobbies/Photo14.jpeg'],
  },
};


export const DIRECTORY_PAGES = {
  projects: {
    path: '~/projects',
    title: 'Projects',
    intro: "A collection of builds, CAD models, and other shenanigans.",
    itemPathPrefix: 'projects',
    items: PROJECTS,
    showModels: true,
  },
  research: {
    path: '~/research',
    title: 'Research',
    intro: 'Research over time :)',
    itemPathPrefix: 'research',
    items: RESEARCH,
  },
  experience: {
    path: '~/experience',
    title: 'Experience',
    intro: 'Internships and industry work experience.',
    itemPathPrefix: 'experience',
    items: EXPERIENCE,
  },
  hobbies: {
    path: '~/hobbies',
    title: 'Hobbies',
    intro: 'Personal interests, hobbies, and things I enjoy doing.',
    itemPathPrefix: 'hobbies',
    items: HOBBIES,
  },
};

export const CONTACT_INFO = {
  email: 'infiniteocean100@gmail.com',
  github: 'github.com/terminatingcoder101',
  linkedin: 'linkedin.com/in/sagar-s-3a1b81244/',
};
